export default {
    selectedPeriod: null,
    availablePeriods: [],
    loading: false,
    switching: false,
    error: null,
}

